import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "gatsby"

import SwipeableViews from 'react-swipeable-views'

import { withStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'

import iPhone01 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_01.png'
import iPhone02 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_02.png'
import iPhone03 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_03.png'
import iPhone04 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_04.png'
import iPhone05 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_05.png'
import iPhone06 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_06.png'
import iPhone07 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_07.png'
import iPhone08 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_08.png'
import iPhone09 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_09.png'
import iPhone10 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_10.png'
import iPhone11 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_11.png'
import iPhone12 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_12.png'
import iPhone13 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_13.png'
import iPhone14 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_14.png'
import iPhone15 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_15.png'
import iPhone16 from '../../../assets/images/Software/iPhone_Wizard/IPhone_App_Wizard_16.png'

function TabContainer(props) {
  const { children, dir } = props;

  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100 vw',
    position: 'relative',
  },
  topbar: {
    backgroundColor: '#1274d3',
  },
  imagecontainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  images: {
    maxHeight: 600,
    margin: 0,
  },
  textcontainer: {
    marginBottom: 15,
  },
  paper: {
    padding: 15
  }
});

class FloatingGallery extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <AppBar position="static" className={classes.topbar}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Step 1" />
            <Tab label="Step 2" />
            <Tab label="Step 3" />
            <Tab label="Step 4" />
            <Tab label="Step 5" />
            <Tab label="Step 6" />
            <Tab label="Step 7" />
            <Tab label="Step 8" />
            <Tab label="Step 9" />
            <Tab label="Step 10" />
            <Tab label="Step 11" />
            <Tab label="Step 12" />
            <Tab label="Step 13" />
            <Tab label="Step 14" />
            <Tab label="Step 15" />
            <Tab label="Step 16" />
          </Tabs>
        </AppBar>
        <Paper className={classes.paper} elevation={1}>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.value}
            onChangeIndex={this.handleChangeIndex}
          >
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[01]</strong> Start by entering the <strong>Cameras</strong> menu and select the <strong>Installation Assistant</strong>.<br/><br/>
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone01} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[02]</strong> You can find the <strong>QR Code</strong> in the <Link to="/Web_User_Interface/1080p_Series/Network/Remote_Access/">WebUI</Link> (A), printed on the label of your camera (B) or on the package.
              </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone02} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[03]</strong> Use the app to scan the QR code from your camera or camera package. If your camera does not have a QR code, please manually select the camera model in the next step.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone03} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[04]</strong> Click <strong>Next</strong> to continue.<br /><br />
              </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone04} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[05]</strong> Select wether your camera is powered over <strong>Power-over-Ethernet</strong> or if you are using the power supply that came with your camera. If your camera doesn&apos;t support PoE, you will be asked for <strong>WiFi</strong> instead (see Step 11).
              </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone05} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[06]</strong> Once your camera is powered up connect it to your internet router with the Ethernet cable that came with your camera. Wait a minute and start a <strong>Camera Search</strong>.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone06} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[07]</strong> The app will detect all INSTAR cameras on your local network. Select the one that you want to add. If your camera does not show choose to <Link to="/Software/iOS/InstarVision/iPhone/DDNS/">add it manually</Link>.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone07} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[08]</strong> You will now be asked to enter the admin login of your camera. If you haven&apos;t set it up before this will be the default usermane <strong>admin</strong> and password <strong>instar</strong>. This can be changed later inside the app.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone08} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[09]</strong> Please choose a name for your camera. <br/><br/>
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone09} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[10]</strong> You can verify that the network configuration - as set by the camera search earlier - is correct. Then click <strong>Next</strong>.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone10} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[11]</strong> You can now choose if you want to connect your camera to your local WiFi <strong>WPS</strong> or keep using an Ethernet cable.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone11} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[12]</strong> If you have choose to use WiFi, please make sure that your cameras antenna is connected and your camera is positioned next to your internet router.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone12} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[13]</strong> Make sure that your camera is still connected to it&apos;s power supply and the power LEDs is on.<br/><br/>
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone13} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[14]</strong> Activate the WPS mode on your router - please refer to your routers user manual for instructions.<br/><br/>
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone14} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[15]</strong> Click and hold the <strong>WPS/Reset button</strong> on your camera for <strong>3-4s</strong>. The WPS mode will stay active for <strong>60s</strong> once activated. (Continue with step 9)
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone15} className={classes.images} />
              </div>
            </TabContainer>
            <TabContainer dir={theme.direction}>
              <div className={classes.textcontainer}>
                <strong>[16]</strong> You can now continue with adding the the remote access via the <Link to="/Software/iOS/InstarVision/iPhone/P2P/">Point2Point (P2P)</Link> or <Link to="/Software/iOS/InstarVision/iPhone/DDNS/">DDNS</Link> service.
                </div>
              <div className={classes.imagecontainer}>
                <img alt="InstarVision Android App" src={iPhone16} className={classes.images} />
              </div>
            </TabContainer>
          </SwipeableViews>
        </Paper>
      </div>
    );
  }
}

FloatingGallery.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(FloatingGallery)